var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        title: _vm.$t("CargoMsg.Cargo_AbnormalComment"),
        "close-on-click-modal": false,
        visible: _vm.innerVisible,
        width: "430px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-bottom": "10px" }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "70px",
                "label-position": "left"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_MarkAbnormal") } },
                    [
                      _c("el-checkbox", {
                        on: { change: _vm.abnormalCheckHandler },
                        model: {
                          value: _vm.abnormal,
                          callback: function($$v) {
                            _vm.abnormal = $$v
                          },
                          expression: "abnormal"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.abnormal
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_AbnormalState"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "295px" },
                              model: {
                                value: _vm.abnormalState,
                                callback: function($$v) {
                                  _vm.abnormalState = $$v
                                },
                                expression: "abnormalState"
                              }
                            },
                            _vm._l(
                              _vm.SystemConstants.OCABNORMAL_STATE,
                              function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_AbnormalRemark") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "295px" },
                        attrs: { maxlength: 200 },
                        model: {
                          value: _vm.abnormalRemark,
                          callback: function($$v) {
                            _vm.abnormalRemark = $$v
                          },
                          expression: "abnormalRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.confirm }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }